import React, { createContext, useState } from "react";
export const VideoContext = createContext();
export const  VideoContextProvider = (props) => {
  const [mute , setMute ] = useState(true);
  const [x , setX] = useState(false);
  function change() {
    if (!x ) {
      if ( !mute ){ setMute(true) } 
      else{ setMute(false)  }
    }
    setX(false) 
  }
  function changeData() {
    setX(true) ;
    if (!mute) { setMute(true) }
    else{ setX(false) }
  }

  return ( 
    <VideoContext.Provider value={
        { 
          mute : mute  ,
          changeData : changeData , 
          change : change  
        }
      }>{props.children}
    </VideoContext.Provider> 
  );
}  